
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/[handle]",
      function () {
        return require("private-next-pages/product/[handle].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/[handle]"])
      });
    }
  